var map = {
	"./airasiafood.jpeg": "5dd5",
	"./bgmain.jpg": "dd1b",
	"./bungkusit.png": "8d55",
	"./chaticon.png": "212a",
	"./declinedorder.png": "3fbc",
	"./delivery.svg": "35eb",
	"./dinein.svg": "fa06",
	"./easi.jpeg": "2cbf",
	"./food-item-default.jpg": "923e",
	"./food-item-default.webp": "ba0a",
	"./foodpanda.jpeg": "7dde",
	"./grabfood.png": "d5a5",
	"./grunge.webp": "2f63",
	"./mayflag.svg": "ebc2",
	"./payment-method-bst.png": "b18e",
	"./payment-method-fpx.png": "afa4",
	"./payment-method-gpo.png": "decf",
	"./payment-method-ip8.png": "1301",
	"./payment-method-mpo.png": "f6e0",
	"./payment-method-shp.png": "706e",
	"./payment-method-tng.png": "6a31",
	"./pendingorder.png": "a552",
	"./pickup.svg": "72ea",
	"./predinein.svg": "198c",
	"./qr-code-scan.svg": "86de",
	"./reservation.svg": "3b8e",
	"./shopeefood.jpeg": "02dd",
	"./smicon.svg": "f6e4",
	"./successavatar.png": "25f5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";